(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-introduce"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const elements = document.querySelectorAll(".fade-in-card");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("fade-in-visible");
          observer.unobserve(entry.target); 
        }
      });
    },
    {
      threshold: 0.01,
    }
  );

  elements.forEach((el) => observer.observe(el));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-servicebox"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const elements = document.querySelectorAll(".fade-in-card");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("fade-in-visible");
          observer.unobserve(entry.target); 
        }
      });
    },
    {
      threshold: 0.01,
    }
  );

  elements.forEach((el) => observer.observe(el));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-template"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const elements = document.querySelectorAll(".fade-in-card");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("fade-in-visible");
          observer.unobserve(entry.target); 
        }
      });
    },
    {
      threshold: 0.01,
    }
  );

  elements.forEach((el) => observer.observe(el));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const elements = document.querySelectorAll(".fade-in-card");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("fade-in-visible");
          observer.unobserve(entry.target); 
        }
      });
    },
    {
      threshold: 0.01,
    }
  );

  elements.forEach((el) => observer.observe(el));
});

document.addEventListener("DOMContentLoaded", function () {
  const track = document.querySelector(".testimonial-track");
  if (!track) return;

  const prevBtn = document.querySelector(".slider-arrow.prev");
  const nextBtn = document.querySelector(".slider-arrow.next");
  const container = document.querySelector(".testimonial-section") || track.parentElement;

  let autoplayInterval = null;
  const AUTOPLAY_MS = 4000;
  let visible = getVisibleCount();

  function getOriginalCards() {
    return Array.from(track.querySelectorAll(".testimonial-card")).filter(n => !n.classList.contains("clone"));
  }

  function removeClones() {
    track.querySelectorAll(".clone").forEach(n => n.remove());
  }

  function buildClones() {
    removeClones();
    const originals = getOriginalCards();
    if (originals.length === 0) return;

    for (let i = 0; i < visible; i++) {
      const node = originals[i % originals.length].cloneNode(true);
      node.classList.add("clone");
      track.appendChild(node);
    }

    for (let i = visible; i > 0; i--) {
      const node = originals[originals.length - i].cloneNode(true);
      node.classList.add("clone");
      track.insertBefore(node, track.firstChild);
    }
  }

  function getGap() {
    const g = getComputedStyle(track).gap;
    return g ? parseFloat(g) : 24;
  }

  function getStepWidth() {
    const first = track.querySelector(".testimonial-card");
    return first ? first.getBoundingClientRect().width + getGap() : 0;
  }

  let index = 0;

  function setInstantTransform(px) {
    track.style.transition = "none";
    track.style.transform = `translateX(${px}px)`;
    track.offsetHeight;
    track.style.transition = "transform 0.5s ease";
  }

  function updateTransformForIndex() {
    const step = getStepWidth();
    track.style.transform = `translateX(${-index * step}px)`;
  }

  function setupSlider() {
    visible = getVisibleCount();
    const originals = getOriginalCards();
    if (originals.length === 0) return;

    removeClones();
    buildClones();
    index = visible;
    setInstantTransform(-index * getStepWidth());
  }

  track.addEventListener("transitionend", () => {
    const originals = getOriginalCards();
    const origCount = originals.length;
    if (origCount === 0) return;

    if (index >= origCount + visible) {
      index = visible;
      setInstantTransform(-index * getStepWidth());
    } else if (index < visible) {
      index = origCount + visible - 1;
      setInstantTransform(-index * getStepWidth());
    }
  });

  function slideNext() {
    index++;
    updateTransformForIndex();
  }

  function slidePrev() {
    index--;
    updateTransformForIndex();
  }

  function startAutoplay() {
    stopAutoplay();
    autoplayInterval = setInterval(slideNext, AUTOPLAY_MS);
  }

  function stopAutoplay() {
    if (autoplayInterval) clearInterval(autoplayInterval);
    autoplayInterval = null;
  }

  if (container) {
    container.addEventListener("mouseenter", stopAutoplay);
    container.addEventListener("mouseleave", startAutoplay);
  }

  if (nextBtn) nextBtn.addEventListener("click", () => { slideNext(); stopAutoplay(); startAutoplay(); });
  if (prevBtn) prevBtn.addEventListener("click", () => { slidePrev(); stopAutoplay(); startAutoplay(); });

  let touchStartX = 0;
  track.addEventListener("touchstart", e => { touchStartX = e.touches[0].clientX; stopAutoplay(); }, { passive: true });
  track.addEventListener("touchend", e => {
    const dx = e.changedTouches[0].clientX - touchStartX;
    if (Math.abs(dx) > 40) (dx < 0 ? slideNext() : slidePrev());
    startAutoplay();
  }, { passive: true });

  let lastVisible = getVisibleCount();
  window.addEventListener("resize", () => {
    const nowVis = getVisibleCount();
    if (nowVis !== lastVisible) {
      lastVisible = nowVis;
      stopAutoplay();
      setTimeout(() => {
        setupSlider();
        startAutoplay();
      }, 120);
    } else {
      setInstantTransform(-index * getStepWidth());
    }
  });

  function getVisibleCount() {
    const w = window.innerWidth;
    if (w <= 767) return 1;
    if (w <= 1024) return 2;
    return 3;
  }

  setupSlider();
  startAutoplay();
});

  } catch(e) { console.error(e); }
})();
})();
